import { notEmpty } from '@festina-life/core'
import { useMemo } from 'react'

import { useCopyChildAction } from './useCopyChildAction'
import { usePasteChildAction } from './usePasteChildAction'
import { useRemoveChildAction } from './useRemoveChildAction'

export const useChildActions = ({
  isRemoveAllowed,
}: {
  isRemoveAllowed: boolean
}) => {
  const copyAction = useCopyChildAction()
  const removeAction = useRemoveChildAction(isRemoveAllowed)
  const pasteAction = usePasteChildAction()

  return useMemo(
    () => [copyAction, pasteAction, removeAction].filter(notEmpty),
    [copyAction, pasteAction, removeAction],
  )
}
